import axios from 'axios'

// Create axios instance with base configuration
const api = axios.create({
  baseURL: import.meta.env.VITE_API_URL || 'http://localhost:5000/api',
  headers: {
    'Content-Type': 'application/json',
  },
})

// Request interceptor to add auth token
api.interceptors.request.use(
  (config) => {
    const token = localStorage.getItem('token')
    if (token) {
      config.headers.Authorization = `Bearer ${token}`
    }
    return config
  },
  (error) => {
    return Promise.reject(error)
  }
)

// Response interceptor to handle errors
api.interceptors.response.use(
  (response) => response,
  (error) => {
    if (error.response?.status === 401) {
      localStorage.removeItem('token')
      window.location.href = '/login'
    }
    return Promise.reject(error)
  }
)

const cartService = {
  /** get-user-cart returns `{ success, data: lineItems[] }`; also supports legacy `.items` or a bare array. */
  normalizeCartLineItems (payload) {
    if (payload == null) return []
    if (Array.isArray(payload)) return payload
    if (Array.isArray(payload.data)) return payload.data
    if (Array.isArray(payload.items)) return payload.items
    return []
  },

  async addToCart (cartData) {
  try {
    const response = await api.post(`/cart/add-to-cart`, cartData);
    return response.data;
  } catch (error) {
    console.error('Error adding to cart:', error);
    throw error;
  }
},

async getUserCart() {
  try {
    const response = await api.get(`/cart/get-user-cart`);
    return response.data;
  } catch (error) {
    console.error('Error adding to cart:', error);
    throw error;
  }
},

async deleteCartItem(cartItemId) {
  try {
    const response = await api.delete(`/cart/delete-cart-item/${encodeURIComponent(cartItemId)}`);
    return response.data;
  } catch (error) {
    console.error('Error adding to cart:', error);
    throw error;
  }
},

async deleteAllCartItems() {
  try {
    const response = await api.delete(`/cart/delete-all-cart-items`);
    return response.data;
  } catch (error) {
    console.error('Error deleting all cart items:', error);
    throw error;
  }
},



}

export default cartService


export const { addToCart, getUserCart, normalizeCartLineItems } = cartService